// productionSelectionApi.ts

import { APIFinalArgs, QueryResponse } from '@common/types/queryState';
import { apiPaths, baseApi } from '@services';
import { transformProduction } from '../mappers';
import { BackendProduction, GetProductionsArgs, Production } from '../types';

const extendedApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getProductions: builder.query<
            QueryResponse<Production>,
            APIFinalArgs<GetProductionsArgs>
        >({
            query: ({ params }) => ({
                url: apiPaths.data.getProductions(),
                params,
            }),
            transformResponse: (response: BackendProduction[], meta, arg) => {
                const totalResultsHeader = meta?.response?.headers.get(
                    'x-pagination-total-results',
                );
                const totalCount = parseInt(totalResultsHeader ?? '0', 10);
                const data = transformProduction(response, meta, arg);

                return {
                    data,
                    totalCount,
                };
            },
        }),
        getAvatar: builder.query<string, { productionId: string }>({
            query: ({ productionId }) => ({
                url: apiPaths.productions.getAvatar(productionId),
                responseHandler: async (response) => {
                    if (!response.ok) {
                        const error = await response.text();
                        throw new Error(
                            `Failed to fetch avatar: ${response.status} - ${error}`,
                        );
                    }

                    const blob = await response.blob();
                    return URL.createObjectURL(blob);
                },
            }),
            keepUnusedDataFor: 0,
        }),
    }),
});

export const { useGetProductionsQuery, useGetAvatarQuery } = extendedApi;

export default extendedApi.endpoints;
